
import { Vue, Prop, Watch, Component, Ref, Emit } from "vue-property-decorator";
import { WidgetSettingResource } from "@/models/api/system/widgets";
import { rawApi } from "@/lib/api";
import { Doughnut, Bar } from 'vue-chartjs'
import { getModule } from "vuex-module-decorators";
import BillToSelect from "@/components/form/BillToSelect.vue";
import Select from "@/components/form/Select.vue";

import { SystemModule } from "@/store/modules";
import WidgetModule from "@/store/modules/widgets";
import notifications from "@/lib/notifications";

import {
  Chart,
  registerables,
} from 'chart.js'

const widgetModule = getModule(WidgetModule);
const systemModule = getModule(SystemModule);

Chart.register( ...registerables );

interface OnTimeMetricParameters
{
    startDays: number;
    endDays: number;
    billTo: string;
    facility: string;
    deliveryForIds: string;
}

interface OnTimeMetricResults
{
    facility: string;
    onTime: number;
    early: number;
    late: number;
    total: number;
    from: string;
    to: string;
}

interface DayRange
{
    label: string;
    start: number;
    end: number;
}

@Component({
  components: {
    Doughnut, Bar, Chart, Select
  }
})
export default class OnTimeMetricWidget extends Vue {
    data: any = null;
    doughnutOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        plugins:{
            legend: {
                position: 'none'
            }
        }
    };
    barOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        plugins:{
            legend: {
                position: 'none'
            }
        },
        scales: {
            xAxes: {
                display: false
            }
        }
    };

    loading: boolean = false;
    isEditModalVisible: boolean = false;

    doughnutWidth: number = 400;
    doughnutHeight: number = 400;

    onTimeColor: string = '#00bfa0';
    earlyColor: string = '#0bb4ff';
    lateColor: string = '#e60049';

    onTime: number = 0;
    early: number = 0;
    late: number = 0;
    total: number = 0;
    from: string = '';
    to: string = '';

    showDoughnut: boolean = true;
    showAmounts: boolean = true;

    dayRange: string = null;

    dayRanges: DayRange[] = [
        { label: 'Today', start: 0, end: 0 },
        { label: 'Last 7 Days', start: 7, end: 0 },
        { label: 'Last 30 Days', start: 30, end: 0 },
        { label: 'Last 60 Days', start: 60, end: 0 },
        { label: 'Last 90 Days', start: 90, end: 0 }
    ];    

    getMetric(value: number) {
        if (this.showAmounts) {
            return `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
        }
            
        return `${Math.round(value/this.total*1000)/10}%`;
    }

    metricTitle: string = '';
    metricFacilities: string[] = [];
    metricBillTo: string = '';
    metricDeliveryForIds: number[] = [];
    metricParameters: OnTimeMetricParameters = {
        startDays: 0,
        endDays: 0,
        billTo: '',
        facility: '',
        deliveryForIds: ''
    };

    @Prop({ required: true})
    widgetSetting: WidgetSettingResource;

    remove() {
        this.$emit('remove', this.widgetSetting.id);
    }

    async mounted() {
        this.loadMetricData();
    }

    async loadMetricData() {
        this.loading = true;
        var p: OnTimeMetricParameters = JSON.parse(this.widgetSetting.settings);
        const response = await rawApi.get<OnTimeMetricResults>(`/widget/onTime?startDays=${p.startDays}&endDays=${p.endDays}&billTo=${p.billTo}&facility=${p.facility}&deliveryForIds=${p.deliveryForIds}`);

        this.onTime = response.data.onTime;
        this.early = response.data.early;
        this.late = response.data.late;
        this.total = response.data.total;
        this.from = response.data.from;
        this.to = response.data.to;

        this.data = {
            labels: ['On Time', 'Early', 'Late'],
            datasets: [
                {
                backgroundColor: [this.onTimeColor, this.earlyColor, this.lateColor],
                data: [this.onTime, this.early, this.late]
                }
            ]
        }
        this.loading = false;
    }

    configure() {
        this.metricParameters = JSON.parse(this.widgetSetting.settings);
        this.dayRanges.forEach(x => {
            if (x.start == this.metricParameters.startDays && x.end == this.metricParameters.endDays) this.dayRange = x.label;
        });

        this.metricTitle = this.widgetSetting.title;

        var facilityCodes = this.metricParameters.facility.split(',')
        facilityCodes = facilityCodes.filter(x => x != '');
        this.metricFacilities = facilityCodes;

        var deliveryForIds = this.metricParameters.deliveryForIds.split(',').filter(x => x != '');
        this.metricDeliveryForIds = deliveryForIds.map(x => parseInt(x));

        this.isEditModalVisible = true;
    }

    async saveConfiguration() {
        if (!this.dayRange) {
            notifications.error('Error', 'Please select a date range.');
            return;
        }

        var range = this.dayRanges.find(x => x.label == this.dayRange);

        this.isEditModalVisible = false;
        this.metricParameters.facility = this.metricFacilities.join(',');
        this.metricParameters.deliveryForIds = this.metricDeliveryForIds.join(',');
        this.metricParameters.billTo = this.metricBillTo;
        this.widgetSetting.title = this.metricTitle;
        this.metricParameters.startDays = range.start;
        this.metricParameters.endDays = range.end;
        this.widgetSetting.settings = JSON.stringify(this.metricParameters);

        await widgetModule.updateWidgetSetting(this.widgetSetting);
        await this.loadMetricData();
        notifications.success('Saved', 'Metric settings updated.')
    }

    getToggleClass(side: string, value: boolean){
        return `toggle ${side}${(value && side == 'left') || (!value && side == 'right') ? ' selected': ''}`;
    }

    isDrillDownAvailable() : boolean {
        return false;
    }

    showDrillDown() {
        
    }
}
